<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      d="M12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM7.57 18.28C8 17.38 10.62 16.5 12.5 16.5C14.38 16.5 17.01 17.38 17.43 18.28C16.07 19.36 14.36 20 12.5 20C10.64 20 8.93 19.36 7.57 18.28ZM18.86 16.83C17.43 15.09 13.96 14.5 12.5 14.5C11.04 14.5 7.57 15.09 6.14 16.83C5.12 15.49 4.5 13.82 4.5 12C4.5 7.59 8.09 4 12.5 4C16.91 4 20.5 7.59 20.5 12C20.5 13.82 19.88 15.49 18.86 16.83ZM12.5 6C10.56 6 9 7.56 9 9.5C9 11.44 10.56 13 12.5 13C14.44 13 16 11.44 16 9.5C16 7.56 14.44 6 12.5 6ZM12.5 11C11.67 11 11 10.33 11 9.5C11 8.67 11.67 8 12.5 8C13.33 8 14 8.67 14 9.5C14 10.33 13.33 11 12.5 11Z"
      fill="url(#paint0_linear_5364_4494)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5364_4494"
        x1="2.5"
        y1="2"
        x2="22.568"
        y2="21.9315"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" class="fill-1" />
        <stop offset="1" class="fill-2" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
.fill-1 {
  stop-color: #df252a;
}

.fill-2 {
  stop-color: #a20004;
}
</style>
